export var EventDetailsPagesType;
(function (EventDetailsPagesType) {
    EventDetailsPagesType[EventDetailsPagesType["DETAILS_PAGE_ENABLED"] = 1] = "DETAILS_PAGE_ENABLED";
    EventDetailsPagesType[EventDetailsPagesType["DETAILS_PAGE_DISABLED"] = 2] = "DETAILS_PAGE_DISABLED";
})(EventDetailsPagesType || (EventDetailsPagesType = {}));
export var EventDetailsAlignment;
(function (EventDetailsAlignment) {
    EventDetailsAlignment[EventDetailsAlignment["LEFT"] = 1] = "LEFT";
    EventDetailsAlignment[EventDetailsAlignment["CENTER"] = 2] = "CENTER";
    EventDetailsAlignment[EventDetailsAlignment["RIGHT"] = 3] = "RIGHT";
})(EventDetailsAlignment || (EventDetailsAlignment = {}));
export var EventDetailsButtonStyle;
(function (EventDetailsButtonStyle) {
    EventDetailsButtonStyle[EventDetailsButtonStyle["HOLLOW"] = 1] = "HOLLOW";
    EventDetailsButtonStyle[EventDetailsButtonStyle["HOLLOW_ROUNDED"] = 2] = "HOLLOW_ROUNDED";
    EventDetailsButtonStyle[EventDetailsButtonStyle["FULL"] = 3] = "FULL";
    EventDetailsButtonStyle[EventDetailsButtonStyle["FULL_ROUNDED"] = 4] = "FULL_ROUNDED";
})(EventDetailsButtonStyle || (EventDetailsButtonStyle = {}));
export var EventDetailsImagePosition;
(function (EventDetailsImagePosition) {
    EventDetailsImagePosition[EventDetailsImagePosition["TOP_LEFT"] = 1] = "TOP_LEFT";
    EventDetailsImagePosition[EventDetailsImagePosition["TOP_CENTER"] = 2] = "TOP_CENTER";
    EventDetailsImagePosition[EventDetailsImagePosition["TOP_RIGHT"] = 3] = "TOP_RIGHT";
    EventDetailsImagePosition[EventDetailsImagePosition["CENTER_LEFT"] = 4] = "CENTER_LEFT";
    EventDetailsImagePosition[EventDetailsImagePosition["CENTER"] = 5] = "CENTER";
    EventDetailsImagePosition[EventDetailsImagePosition["CENTER_RIGHT"] = 6] = "CENTER_RIGHT";
    EventDetailsImagePosition[EventDetailsImagePosition["BOTTOM_LEFT"] = 7] = "BOTTOM_LEFT";
    EventDetailsImagePosition[EventDetailsImagePosition["BOTTOM_CENTER"] = 8] = "BOTTOM_CENTER";
    EventDetailsImagePosition[EventDetailsImagePosition["BOTTOM_RIGHT"] = 9] = "BOTTOM_RIGHT";
})(EventDetailsImagePosition || (EventDetailsImagePosition = {}));
export var EventDetailsImageRatio;
(function (EventDetailsImageRatio) {
    EventDetailsImageRatio[EventDetailsImageRatio["16:9"] = 1] = "16:9";
    EventDetailsImageRatio[EventDetailsImageRatio["1:1"] = 2] = "1:1";
})(EventDetailsImageRatio || (EventDetailsImageRatio = {}));
export var DateSize;
(function (DateSize) {
    DateSize[DateSize["SMALL"] = 1] = "SMALL";
    DateSize[DateSize["MEDIUM"] = 2] = "MEDIUM";
})(DateSize || (DateSize = {}));
export var WIDGET_TYPE;
(function (WIDGET_TYPE) {
    WIDGET_TYPE[WIDGET_TYPE["SINGLE"] = 1] = "SINGLE";
    WIDGET_TYPE[WIDGET_TYPE["LIST"] = 2] = "LIST";
    WIDGET_TYPE[WIDGET_TYPE["FEATURED"] = 3] = "FEATURED";
})(WIDGET_TYPE || (WIDGET_TYPE = {}));
export var HEADER_LAYOUT;
(function (HEADER_LAYOUT) {
    HEADER_LAYOUT[HEADER_LAYOUT["CLASSIC"] = 1] = "CLASSIC";
    HEADER_LAYOUT[HEADER_LAYOUT["SIDE_BY_SIDE"] = 2] = "SIDE_BY_SIDE";
})(HEADER_LAYOUT || (HEADER_LAYOUT = {}));
export var HEADER_IMAGE_ALIGNMENT;
(function (HEADER_IMAGE_ALIGNMENT) {
    HEADER_IMAGE_ALIGNMENT[HEADER_IMAGE_ALIGNMENT["LEFT"] = 1] = "LEFT";
    HEADER_IMAGE_ALIGNMENT[HEADER_IMAGE_ALIGNMENT["RIGHT"] = 2] = "RIGHT";
})(HEADER_IMAGE_ALIGNMENT || (HEADER_IMAGE_ALIGNMENT = {}));
export var TICKET_PICKER_LAYOUT;
(function (TICKET_PICKER_LAYOUT) {
    TICKET_PICKER_LAYOUT[TICKET_PICKER_LAYOUT["LIST"] = 1] = "LIST";
    TICKET_PICKER_LAYOUT[TICKET_PICKER_LAYOUT["CARDS"] = 2] = "CARDS";
})(TICKET_PICKER_LAYOUT || (TICKET_PICKER_LAYOUT = {}));
//# sourceMappingURL=event-details-enums.js.map